module.exports = __webpack_public_path__ + "img/backspace-reverse-fill.1c7f5a67.svg";